import React, { useState, useEffect, useRef } from "react";
import { Button } from "semantic-ui-react";
import {
  Add,
  Recipe,
  Pizza,
  Allergen,
  Categories,
  Unit,
  Alert,
  Filter,
} from "ceicons";
import { useTranslation } from "ceco-polyglot";
import { RecipeModal } from "../modals/RecipeModal";
import { IngredientModal } from "../modals/IngredientModal";
import { AllergenModal } from "../modals/AllergenModal";
import { CategoryModal } from "../modals/CategoryModal";
import { AlertModal } from "../modals/AlertModal";
import { UnitModal } from "../modals/UnitModal";
import { FiltersModal } from "../modals/FiltersModal";

import "./createButton.scss";
const CreateButton = ({ allLabel, allCategories, refetchData }) => {
  const [active, setActive] = useState(false);
  const t = useTranslation();
  const wrapperRef = useRef(null);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setActive(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(wrapperRef);
  return (
    <div className="dropdown-button" ref={wrapperRef}>
      <Button
        onClick={() => {
          setActive(!active);
        }}
        labelPosition="right"
        icon={true}
        className="createButton"
      >
        {t("button.create")}
        <div className="add-icon-container">
          <Add />
        </div>
      </Button>
      <div className={`slide-card ${active ? "active" : ""}`}>
        <div className="inner-card" onClick={() => setActive(false)}>
          <RecipeModal
            trigger={
              <div className="option-button">
                <Recipe /> {t("dropdown.new_recipe")}
              </div>
            }
            allLabel={allLabel}
            allCategories={allCategories}
            refetchData={refetchData}
          />
          <IngredientModal
            trigger={
              <div className="option-button">
                <Pizza /> {t("dropdown.new_ingredient")}
              </div>
            }
            refetchData={refetchData}
          />
          <AllergenModal
            trigger={
              <div className="option-button">
                <Allergen /> {t("dropdown.new_allergen")}
              </div>
            }
            refetchData={refetchData}
          />
          <CategoryModal
            trigger={
              <div className="option-button">
                <Categories /> {t("dropdown.new_category")}
              </div>
            }
            refetchData={refetchData}
          />
          <UnitModal
            trigger={
              <div className="option-button">
                <Unit /> {t("dropdown.new_unit")}
              </div>
            }
            refetchData={refetchData}
          />
          <AlertModal
            trigger={
              <div className="option-button">
                <Alert /> {t("dropdown.new_alert")}
              </div>
            }
            refetchData={refetchData}
          />
          <FiltersModal
            trigger={
              <div className="option-button">
                <Filter /> {t("dropdown.new_filter")}
              </div>
            }
            refetchData={refetchData}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateButton;
